<template>
    <div>

        <button-white @click="open">
            <span v-show="editable">Bearbeiten</span>
        </button-white>

        <portal to="modal" v-if="edit">
            <modal @close="edit = false">
                <template slot="header">Bearbeiten</template>

                <div class="flex justify-end">
                    <confirm-dialog @confirmed="remove" v-show="editable">
                        <button-delete><template slot="icon"><i class="fa fa-trash mr-2"></i></template> Löschen</button-delete>
                        <template slot="header">Löschen</template>
                        <template slot="question">Soll <span class="font-bold">{{ item.name }}</span>
                            wirklich gelöscht werden?
                        </template>
                        <template slot="confirm">Löschen</template>
                    </confirm-dialog>
                </div>

                <input-text class="mb-4" v-model="item.name">
                    Bezeichnung z.B. 456
                </input-text>

                <toggle-group v-model="item.requires_confirmation">
                    Buchungen müssen von einem Admin bestätigt werden.
                </toggle-group>

                <input-field class="mb-4">
                    Etage
                    <template slot="input">
                        <select
                            class="w-full form-select h-full py-0 pl-3 pr-7 border-transparent bg-transparent text-gray-500 sm:text-sm sm:leading-5"
                            v-model="floor">
                            <option :value="null">Ohne Etage</option>
                            <option v-for="f in floors" :value="f.id">{{ f.name }}</option>
                        </select>
                    </template>
                </input-field>

                <multi-select class="mb-4" v-model="selectedEquipment" :selectable="equipment">
                    Ausstattung
                </multi-select>

                <div class="mb-4">
                        <p class="font-medium text-sm">Foto</p>
                        <input type="file" ref="image" @change="handleFileUpload()" class="border">
                </div>

                    <div class="mb-4 flex" v-show="imageLink">
                        <img :src="imageLink" class="h-25 border" alt="Foto">
                        <confirm-dialog @confirmed="removeImage">
                            <i class="fa fa-times"></i>
                            <template slot="header">Foto löschen</template>
                            <template slot="question">Soll das Foto wirklich entfernt werden?</template>
                            <template slot="confirm"><button-delete><template slot="icon"><i class="fa fa-trash"></i></template>Löschen</button-delete></template>
                        </confirm-dialog>
                    </div>
                    <div class="mb-4 flex" v-show="!imageLink && item.image">
                        <img :src="item.image" class="h-25 border" alt="Foto">
                        <confirm-dialog @confirmed="removeImage">
                            <i class="fa fa-times"></i>
                            <template slot="header">Foto löschen</template>
                            <template slot="question">Soll das Foto wirklich entfernt werden?</template>
                            <template slot="confirm"><button-delete><template slot="icon"><i class="fa fa-trash"></i></template>Löschen</button-delete></template>
                        </confirm-dialog>
                    </div>

                
                <div v-if="true" class="mb-4">
                    <bookable-position-edit v-model="item"></bookable-position-edit>
                </div>

                <div class="flex justify-end">
                    <button-primary v-show="editable" @click="save()">
                        <template slot="icon"><i class="fa fa-floppy-o mr-2"></i></template> Speichern
                    </button-primary>
                </div>

            </modal>
        </portal>
    </div>

</template>

<script>
import ButtonSecondary from "../UI/ButtonSecondary";
import Modal from "../Modal";
import ConfirmDialog from "../UI/ConfirmDialog";
import ButtonWhite from "../UI/ButtonWhite";
import InputText from "../UI/InputText";
import InputField from "../UI/InputField";
import ButtonDelete from "../UI/ButtonDelete.vue"
import ButtonPrimary from "../UI/ButtonPrimary";
import BookablePositionEdit from "./BookablePositionEdit";
import MultiSelect from "../UI/MultiSelect";
import Toggle from "../UI/Toggle.vue";
import ToggleGroup from "../UI/ToggleGroup.vue";

export default {
    name: "BookableEdit",
    components: {
        ToggleGroup,
        Toggle,
        BookablePositionEdit,
        ButtonPrimary,
        InputField,
        InputText,
        ButtonWhite,
        ConfirmDialog,
        Modal,
        ButtonSecondary,
        MultiSelect,
        ButtonDelete
    },
    props: ['item'],

    inject: ['admin'],

    data: () => ({
        edit: false,
        floors: [],
        floor: null,
        loading: false,
        equipment: [],
        selectedEquipment: [],
        imageLink: '',
    }),

    computed: {
        editable() {
            if (this.admin.is_admin) {
                return true;
            }

            return false;
        },
    },

    methods: {
        remove() {
            this.loading = true;
            axios.post(`/admin/bookables/${this.item.id}`, {
                _method: 'delete',
            })
                .then(() => {
                    this.edit = false;
                    this.loading = false;
                    this.$root.$emit('alert', 'Gelöscht.');
                    this.$emit('updated');
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                });
        },
        async open() {
            this.edit = true;
            this.loading = true;
            this.showEquipment;
            this.floor = this.item.floor_id;
            const responseEquipment = await axios.get('/admin/equipment');
            this.equipment = await responseEquipment.data.data.map(a => ({
                id: a.id,
                text: a.name,
            }));
            this.selectedEquipment = this.item.equipment.map(a => a.id);
            const response = await axios.get('/admin/floors');
            this.floors = await response.data.data;
            this.loading = false;
        },
        save() {
            this.$http.post(`/admin/bookables/${this.item.id}`, {
                _method: 'put',
                name: this.item.name,
                floor_id: this.floor,
                position: this.item.position ?? null,
                equipment: this.selectedEquipment,
                requires_confirmation: this.item.requires_confirmation,
            })
                .then(() => {
                    this.edit = false;
                    this.$root.$emit('alert', 'Gespeichert.');
                    this.$emit('updated');
                })
                .catch(error => {
                    this.$root.$emit('error', error);
                    this.edit = false;
                    this.$emit('updated');
                });
        },
        handleFileUpload() {
            let image = this.$refs.image.files[0];
            let formData = new FormData();
            formData.append('image', image);
            formData.append('_method', 'put');
            window.axios
                .post(`/admin/bookables/${this.item.id}`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then((response) => {
                    this.imageLink = response.data.data.image;
                    this.$emit('updatd');

                })
                .catch(error => {
                    this.$root.$emit('error', error);
                });
        },
        removeImage() {
            this.loading = true;
            window.axios.post(`/admin/bookables/${this.item.id}`, {
                _method: 'put',
                image: '',
            }).then(() => {
                this.loading = false;
                this.imageLink = null;
                this.item.image = null;
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        },
    },
}
</script>

<style scoped>

</style>
